import { useEffect, useRef, useState } from "react";

import { isValidNumber, parsePhoneNumber } from "libphonenumber-js";
import useTranslation from "next-translate/useTranslation";
import PhoneInput from "react-phone-input-2";
import pt from "react-phone-input-2/lang/pt.json";
import "react-phone-input-2/lib/style.css";

import listOfCountries from "pages/[tenant]/payment/components/listOfCountries.json";

import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";
import { useField } from "@unform/core";

import {
  ContainerInputPhone,
  ContentInputPhone,
  InvalidMessage,
  Label,
  Required,
} from "./styles";

const PhoneInputCountry = ({ setIsPhoneNumberValid }) => {
  const { lang } = useTranslation();
  const { countryDDI } = useCheckoutContext();

  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, registerField, defaultValue, error, clearError } =
    useField("phone_number");

  const [phoneValue, setPhoneValue] = useState(defaultValue || "");
  const [localError, setLocalError] = useState("");

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      getValue: () => phoneValue,
      setValue: (_, value) => setPhoneValue(value),
      clearValue: () => setPhoneValue(""),
    });
  }, [fieldName, registerField, phoneValue]);

  useEffect(() => {
    if (defaultValue) {
      setPhoneValue(defaultValue);

      try {
        const detailsPhoneNumber = defaultValue.startsWith("+")
          ? parsePhoneNumber(defaultValue)
          : parsePhoneNumber(`+ ${defaultValue}`);

        const initialCountryCode = detailsPhoneNumber.country;
        validatePhoneNumber(defaultValue, { countryCode: initialCountryCode });
      } catch (error) {
        console.error("Erro ao analisar o número de telefone:", error);
      }
    }
  }, [defaultValue]);

  function translateCountryName(countryCode) {
    const country = listOfCountries.countries.find(
      (c) => c.code === countryCode.toUpperCase(),
    );
    return country ? country.name : countryCode;
  }

  const validatePhoneNumber = (value, country) => {
    if (value && country) {
      try {
        const isValid = isValidNumber(value, country.countryCode.toUpperCase());
        if (isValid) {
          setIsPhoneNumberValid(true);
        } else {
          setIsPhoneNumberValid(false);
        }

        return isValid
          ? true
          : country.countryCode
          ? `Número inválido para ${translateCountryName(country.countryCode)}`
          : "Número inválido";
      } catch (error) {
        return "Erro na validação: " + error.message;
      }
    }
    return true;
  };

  const handleChange = (value, country, e) => {
    setPhoneValue(value);
    const validationMessage = validatePhoneNumber(value, country);
    if (validationMessage !== true) {
      setLocalError(validationMessage);
    } else {
      setLocalError("");
      clearError();
    }
  };

  return (
    <ContainerInputPhone>
      <Label>
        Telefone
        <Required>*</Required>
      </Label>

      <ContentInputPhone error={!!error || !!localError}>
        <PhoneInput
          inputProps={{
            ref: inputRef,
            id: fieldName,
            name: fieldName,
          }}
          country={countryDDI || "br"}
          value={phoneValue}
          onChange={handleChange}
          inputClass="ant-input-checkout"
          localization={lang === "pt-BR" ? pt : undefined}
          specialLabel=""
        />
      </ContentInputPhone>
      {(error || localError) && (
        <InvalidMessage>{error || localError}</InvalidMessage>
      )}
    </ContainerInputPhone>
  );
};

export default PhoneInputCountry;
